import React from 'react';
import { Link } from 'react-router-dom';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Input as FormInput } from '../../Form/Input';
import { Button } from '../../Button';
import './LoginForm.css';
import { withInputClassNames } from './HOC';

const Input = withInputClassNames(FormInput);

const LoginForm = ({ isSubmitting, errors, touched }) => {
  const isEmailInvalid = touched.email ? !!errors.email : undefined;

  return (
    <Form className="login">
      <div className="reset-password__form__header-wrapper">
        <div className="reset-password__form__form-header">Log In</div>
      </div>
      <div className="reset-password__form__subtitle-wrapper">
        <div className="reset-password__form__form-subtitle">
          Need to get started?&nbsp;
          <a href="/getstarted">Create your brief today</a>
        </div>
      </div>
      <div className="form-row">
        <Input
          labelClassName="t-14"
          label="Email"
          name="email"
          invalid={isEmailInvalid}
          showError={false}
        />
      </div>
      <div className="form-row">
        <Input
          labelClassName="t-14"
          label="Password"
          name="password"
          type="password"
        />
      </div>
      <div className="form-row controls-block">
        <Button type="submit" title="Continue" className="form-submit mb-0" />
        <Link to="/forgot-password" className="t-14 d-block forgot-password">
          Forgot password?
        </Link>
      </div>
    </Form>
  );
};

LoginForm.propTypes = {
  isSubmitting: PropTypes.bool,
  errors: PropTypes.object,
  touched: PropTypes.object,
};

export default withFormik({
  handleSubmit: (values, { props, setSubmitting }) =>
    props.onSubmit && props.onSubmit(values, setSubmitting),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email()
      .required(),
  }),
  displayName: 'LoginForm',
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm/LoginForm.js